import NoImagePNG from 'images/no-image.png';

export function toIsoDateOnly(dateStr) {
  if (!dateStr) return null;

  // Si ya viene en ISO "2025-11-11", lo dejamos
  if (dateStr.includes('-')) return dateStr;

  // Si viene como "dd/MM/yyyy"
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
} 

export function formatDate(dateTime, includeHour) {
    if (dateTime === undefined) return null;

    let date = new Date(dateTime);

    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    monthIndex = monthIndex + 1;
    monthIndex = monthIndex < 10 ? '0' + monthIndex : monthIndex;
    hour = hour < 10 ? '0' + hour : hour;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    if (day === undefined) {
        return 'Undefined';
    }

    day = day < 10 ? '0' + day : day;

    if (includeHour) {
        return (
            day +
            '/' +
            monthIndex +
            '/' +
            year +
            ' ' +
            hour +
            ':' +
            minutes +
            'h'
        );
    }

    return day + '/' + monthIndex + '/' + year;
}
/**
 *
 * @param {*} concepto
 * @param {*} url
 * @param {*} config
 * @param {*} data
 * @param {*} exception
 */
export function getLogModel(concepto, url, config, data, exception) {
    return {
        concepto,
        texto: JSON.stringify({
            url,
            config,
            data,
            exception,
        }),
    };
}

/**
 * Return true when is undefined or null or empty or whitespace
 * @value string to validate
 */
export function IsNullORWhitespace(value) {
    if (value === undefined) {
        return true;
    }
    if (value === null) {
        return true;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return true;
    } else {
        return false;
    }
}

export function validateLength(str, min, max) {
    return str.length >= min && str.length < max;
}

export const findUpperCase = str => Boolean(str.match(/[A-Z]/));

export const findLowerCase = str => Boolean(str.match(/[a-z]/));

export const findNumbers = str => Boolean(str.match(/[\d]/));

export const findRepeat3 = str => Boolean(str.match(/(.)\1{2,}/));

export const findSpecialChars = str =>
    Boolean(str.match(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/));

export function Compare(x, y) {
    var p,
        leftChain = [],
        rightChain = [];

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (
        isNaN(x) &&
        isNaN(y) &&
        typeof x === 'number' &&
        typeof y === 'number'
    ) {
        return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
        return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (
        (typeof x === 'function' && typeof y === 'function') ||
        (x instanceof Date && y instanceof Date) ||
        (x instanceof RegExp && y instanceof RegExp) ||
        (x instanceof String && y instanceof String) ||
        (x instanceof Number && y instanceof Number)
    ) {
        return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
        return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
    }

    if (x.constructor !== y.constructor) {
        return false;
    }

    if (x.prototype !== y.prototype) {
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if (typeof y[p] !== typeof x[p]) {
            return false;
        }
    }

    for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if (typeof y[p] !== typeof x[p]) {
            return false;
        }

        switch (typeof x[p]) {
            case 'object':
            case 'function':
                leftChain.push(x);
                rightChain.push(y);

                if (!Compare(x[p], y[p])) {
                    return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

            default:
                if (x[p] !== y[p]) {
                    return false;
                }
                break;
        }
    }

    return true;
}

export const isAppleDeviceOrNavegatorForDates = date => {
    if (!date || typeof date !== 'string') return date;

    let formatDate = date.replace(/ /g, 'T');

    if (formatDate[formatDate.length - 1] !== 'Z') {
        formatDate += 'Z';
    }

    return formatDate;
};

export function disableHTMLOverflow(action) {
    if (action) document.querySelector('html').style.overflowY = 'hidden';
    else document.querySelector('html').style.overflowY = 'auto';
}

export const getImageSource = path => path || NoImagePNG;

export const throttle = (callback, limit) => {
    let waiting = false; // Initially, we're not waiting
    return function () {
        // We return a throttled function
        if (!waiting) {
            // If we're not waiting
            callback.apply(this, arguments); // Execute users function
            waiting = true; // Prevent future invocations
            setTimeout(function () {
                // After a period of time
                waiting = false; // And allow future invocations
            }, limit);
        }
    };
};

export const getCookie = key => {
    const name = key + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const isInternetExplorerNavigator = () => {
    return (
        navigator.userAgent.toUpperCase().indexOf('TRIDENT/') !== -1 ||
        navigator.userAgent.toUpperCase().indexOf('MSIE') !== -1
    );
};

export const promiseAllSettledPolyfill = promises => {
    let mappedPromises = promises.map(p => {
        return p
            .then(value => {
                return {
                    status: 'fulfilled',
                    value,
                };
            })
            .catch(reason => {
                return {
                    status: 'rejected',
                    reason,
                };
            });
    });
    return Promise.all(mappedPromises);
};

export const b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 2000;
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const fileURL = URL.createObjectURL(blob);
    // device detection
    window.open(fileURL);
};

export const validateDocumentId = document => {
    if (typeof document !== 'string') return document;
    const letters = {
        0: 't',
        1: 'r',
        2: 'w',
        3: 'a',
        4: 'g',
        5: 'm',
        6: 'y',
        7: 'f',
        8: 'p',
        9: 'd',
        10: 'x',
        11: 'b',
        12: 'n',
        13: 'j',
        14: 'z',
        15: 's',
        16: 'q',
        17: 'v',
        18: 'h',
        19: 'l',
        20: 'c',
        21: 'k',
        22: 'e',
    };

    const validateLetter = document =>
        document[document.length - 1].toLowerCase() ===
        letters[parseInt(document) % 23];

    if (document.match(/((\d{8})([-]?)([a-z]|[A-Z]{1}))/)) {
        return validateLetter(document) ? 1 : 0; //NIF person
    } else if (
        document.match(
            /(([a-w]|[A-W]{1})([-]?)(\d{7})([-]?)([\d]|[a-z]|[A-Z]{1}))/
        )
    ) {
        return 2; // NIF company
    } else if (
        document.match(/(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))/)
    ) {
        const nieLetterValues = {
            x: 0,
            X: 0,
            y: 1,
            Y: 1,
            z: 2,
            Z: 2,
        };
        return validateLetter(nieLetterValues[document[0]] + document.slice(1))
            ? 3
            : 0; //NIE
    }
    return 0; //Not a valid document format NIF (person/company) / NIE
};
